// extracted by mini-css-extract-plugin
export default {"title":"ValidatorNumbers_title__oDsND","numbers":"ValidatorNumbers_numbers__arZ8Y","item":"ValidatorNumbers_item__WCG8e","value":"ValidatorNumbers_value__fhHfc"};